import { render, staticRenderFns } from "./ExportEvent.vue?vue&type=template&id=2352aa3c&scoped=true&"
import script from "./ExportEvent.vue?vue&type=script&lang=js&"
export * from "./ExportEvent.vue?vue&type=script&lang=js&"
import style0 from "./ExportEvent.vue?vue&type=style&index=0&id=2352aa3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2352aa3c",
  null
  
)

export default component.exports